var $ 			=	require('jquery');
window.toastr 	= 	require('toastr');

var Notify = {

	message: function( level, message ) {
		return toastr[level](message);
	},

	success: function(message) {
		return this.message('success', message);
	},

	info: function(message) {
		return this.message('info', message);
	},

	warning: function(message) {
		return this.message('warning', message);
	},

	error: function(message) {
		return this.message('error', message);
	},

	load: function() {
		var self = this;

		$.ajax({
			url: 		App.base + '/system/notify/get',
			dataType: 	'json'
		}).done(function(data) {
			self.responseToMessages(data);
		});

		return true;
	},

	responseToMessages: function(data) {
		var self = this ;
		$.map(data, function(message) {
			self.message( message.level, message.text );
		});
	}
};

Notify.load();

// --  --------------------------------------------------------------------------------------------

toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-bottom-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

module.exports = Notify;
